import { useEffect, useState } from "react";
import "./pageloader.css";

const MIN_DURATION = 2400;

export default function PageLoader({ isReady = false, onHide }) {
  const [hiding, setHiding] = useState(false);
  const [windowLoaded, setWindowLoaded] = useState(
    document.readyState === "complete"
  );

  // Prati window.load
  useEffect(() => {
    if (windowLoaded) return;

    function onLoad() {
      setWindowLoaded(true);
    }

    window.addEventListener("load", onLoad);
    return () => window.removeEventListener("load", onLoad);
  }, [windowLoaded]);

  // Sakrij kad su oba uvjeta ispunjena: window učitan + podaci stigli
  useEffect(() => {
    if (!windowLoaded || !isReady) return;

    const timer = setTimeout(() => {
      setHiding(true);
    }, MIN_DURATION);

    return () => clearTimeout(timer);
  }, [windowLoaded, isReady]);

  const handleTransitionEnd = () => {
    if (hiding && onHide) onHide();
  };

  return (
    <div
      className={`pl-overlay${hiding ? " pl-hidden" : ""}`}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className="pl-carbon" />

      <div className="pl-inner">
        <p className="pl-logo">
          CARBON<span>CRO</span>
        </p>
        <p className="pl-tag">Enjoy the Journey</p>

        <div className="pl-pill">
          <span className="pl-dot" />
          <span className="pl-dot" />
          <span className="pl-dot" />
        </div>

        <div className="pl-bar-track">
          <div className="pl-bar-fill" />
        </div>
      </div>
    </div>
  );
}